import { WorksheetActionModelSelector } from '@pbx/helpers/worksheets/action-types';

export const WorksheetAction = {
  /**
   * @param entry_points
   * @param actions
   * @return {{items: *[]}}
   *
   * Единожди получаем с бека и отдаем форматтеру,
   * он преобразовывает ответ бекенда в модели из папки @pbx/models/worksheet-action
   * Дальше уже работаем только с этими моделями
   */
  formatItemFromBackend({ entry_points, actions }) {
    const entry_points_format = entry_points.map(i => ({ ...i, type: 'entry' }));
    const items = [...entry_points_format, ...actions];

    const transform_items = items.map(item => {
      const item_model = WorksheetActionModelSelector.getBackendModelByType(item.type, item);
      if (!item_model) {
        throw Error(`Unknown type: ${item.type}`);
      }
      return item_model.toFrontend();
    });
    return { items: transform_items };
  }
};
